import { NgClass } from "@angular/common";
import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { SvgIconComponent } from "@ponder-shared/components/svg-icon.component";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { AdvancedSearchParameter, AdvancedSearchService } from "../advanced-search.service";

@Component({
    selector: "advanced-search-text-input",
    imports: [NgClass, SvgIconComponent],
    templateUrl: "./advanced-search-text-input.component.html"
})
export class AdvancedSearchTextInputComponent {
    @ViewChild("textInput") private textInputRef!: ElementRef<HTMLInputElement>;

    @Input({ required: true }) public type!: AdvancedSearchParameter;
    @Input() public placeholder?: string;

    public hasValue: boolean = false;
    public closeSvgIcon: SvgIcon = SvgIcon.Close;
    
    public constructor(private advancedSearch: AdvancedSearchService) {

    }

    public onChange(value: string): void {
        this.hasValue = value.length > 0;
       this.advancedSearch.setString(this.type, value);
    }

    public onClear(): void {
       this.textInputRef.nativeElement.value = "";
       this.hasValue = false;
       this.advancedSearch.setString(this.type, undefined);
    }
}